export const APPLE_PAY_RETRY_MODAL_CONTENT = {
  title: `Something went wrong`,
  message: `We’re not able to proceed this time. 
  Please try again in a little while. If you’re still having trouble, check your card details or try a different card.`,
  buttonText: 'Use another card',
  secondaryButtonText: 'Cancel'
};
